import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="viewer-data-toggle"
export default class extends Controller {
  static targets = [ "dataView", "toggleBtn" ]

  connect() {
    this.isOpen = false
  }

  toggleData() {
    this.isOpen = !this.isOpen
    const el = this.dataViewTarget

    if (this.isOpen) {
      // Show as mobile overlay
      el.classList.remove("hidden")
      el.classList.add("!block", "!absolute", "inset-0", "bg-brand-bg", "z-30", "overflow-auto", "!max-w-none")
      if (this.hasToggleBtnTarget) {
        this.toggleBtnTarget.textContent = "View Document"
      }
    } else {
      // Hide on mobile, restore desktop classes
      el.classList.add("hidden")
      el.classList.remove("!block", "!absolute", "inset-0", "bg-brand-bg", "z-30", "overflow-auto", "!max-w-none")
      if (this.hasToggleBtnTarget) {
        this.toggleBtnTarget.textContent = "View Extracted Data"
      }
    }
  }
} 
